export default "__VITE_ASSET__8bb22c2f__"